import React from 'react';
import { Box } from '@mui/material';
import { LocalParticipant, Room } from 'livekit-client';
import { LiveStreamState } from '../types';

interface ControlBarProps {
  localParticipant: LocalParticipant | null;
  room: Room | null;
  liveStreamState: LiveStreamState;
  onToggleVideo: () => Promise<void>;
  onToggleAudio: () => Promise<void>;
  onStartLiveStream: () => Promise<void>;
}

export const ControlBar: React.FC<ControlBarProps> = ({
  localParticipant,
  room,
  liveStreamState,
  onToggleVideo,
  onToggleAudio,
  onStartLiveStream,
}) => {

  return (
    <Box display="flex" justifyContent="center" gap={2} p={2}>
      {/* ControlBar is now empty - all controls moved to Header and VideoControls */}
    </Box>
  );
};
